import { Icon } from "@iconify/react/dist/iconify.js";

export function SuccessfulQuotationSubmission({ reference }: { reference: string }) {
    return (
        <div className="grid place-content-center h-full">
            <div className="grid gap-3 rounded-md p-3 shadow-md">
                <div className="grid gap-1 place-items-center">
                    <span className="text-center">Quotation Request Successfully Submitted</span>
                    <br />
                    <div className="grid gap-1 place-items-center bg-green-100 rounded-lg p-3">
                        <Icon icon="mingcute:check-line" className="text-5xl text-green-500" />
                    </div>
                    <br />
                    <span className="text-center"><strong>Quotation Request Reference:</strong> {reference}</span>
                    <br />
                    <span className="text-center">Please check your email for the quotation request.</span>
                    <span className="text-center">You can close this window now.</span>
                </div>
            </div>
        </div>
    );
}